import { removeStyleTag, upsertStyleTag } from "../../domStyles";

let readingMaskEl: HTMLDivElement | null = null;
let readingMaskWindowEl: HTMLDivElement | null = null;
let readingMaskTopEl: HTMLDivElement | null = null;
let readingMaskBottomEl: HTMLDivElement | null = null;
let onReadingMaskMove: ((e: MouseEvent) => void) | null = null;

const MASK_ID = "incluway-reading-mask";
const STYLE_ID = "incluway-reading-mask-style";

function ensureReadingMaskStyle() {
  upsertStyleTag(
    STYLE_ID,
    `
#${MASK_ID} {
  position: fixed;
  inset: 0;
  z-index: 2147483647;
  pointer-events: none;
  opacity: 1;
  will-change: transform;
}

#${MASK_ID} .incluway-reading-mask__shade {
  position: absolute;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.62);
  transition: height 40ms linear, transform 40ms linear;
}

#${MASK_ID} .incluway-reading-mask__shade--top {
  top: 0;
}

#${MASK_ID} .incluway-reading-mask__shade--bottom {
  bottom: 0;
}

#${MASK_ID} .incluway-reading-mask__window {
  position: absolute;
  left: 0;
  width: 100%;
  height: 170px;
  background: transparent;
  border-top: 2px solid rgba(255, 255, 255, 0.7);
  border-bottom: 2px solid rgba(255, 255, 255, 0.7);
  box-shadow:
    inset 0 14px 22px -18px rgba(255, 255, 255, 0.45),
    inset 0 -14px 22px -18px rgba(255, 255, 255, 0.45),
    0 0 0 1px rgba(255, 255, 255, 0.04);
  transition: transform 40ms linear, top 40ms linear;
}

#${MASK_ID} .incluway-reading-mask__window::before,
#${MASK_ID} .incluway-reading-mask__window::after {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  height: 18px;
  pointer-events: none;
}

#${MASK_ID} .incluway-reading-mask__window::before {
  top: 0;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.10),
    rgba(255, 255, 255, 0)
  );
}

#${MASK_ID} .incluway-reading-mask__window::after {
  bottom: 0;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 0.10),
    rgba(255, 255, 255, 0)
  );
}
`.trim(),
  );
}

function ensureReadingMask() {
  if (readingMaskEl) return;

  ensureReadingMaskStyle();

  readingMaskEl = document.createElement("div");
  readingMaskEl.id = MASK_ID;
  readingMaskEl.innerHTML = `
    <div class="incluway-reading-mask__shade incluway-reading-mask__shade--top"></div>
    <div class="incluway-reading-mask__window"></div>
    <div class="incluway-reading-mask__shade incluway-reading-mask__shade--bottom"></div>
  `;

  document.body.appendChild(readingMaskEl);

  readingMaskTopEl = readingMaskEl.querySelector(
    ".incluway-reading-mask__shade--top",
  ) as HTMLDivElement | null;

  readingMaskBottomEl = readingMaskEl.querySelector(
    ".incluway-reading-mask__shade--bottom",
  ) as HTMLDivElement | null;

  readingMaskWindowEl = readingMaskEl.querySelector(
    ".incluway-reading-mask__window",
  ) as HTMLDivElement | null;
}

function updateReadingMask(clientY: number) {
  if (!readingMaskTopEl || !readingMaskBottomEl || !readingMaskWindowEl) return;

  const viewportHeight = window.innerHeight;
  const windowHeight = 170;
  const minTop = 12;
  const maxTop = viewportHeight - windowHeight - 12;

  let windowTop = Math.round(clientY - windowHeight / 2);

  if (windowTop < minTop) windowTop = minTop;
  if (windowTop > maxTop) windowTop = maxTop;

  const topHeight = windowTop;
  const bottomHeight = Math.max(0, viewportHeight - windowTop - windowHeight);

  readingMaskWindowEl.style.top = `${windowTop}px`;
  readingMaskTopEl.style.height = `${topHeight}px`;
  readingMaskBottomEl.style.height = `${bottomHeight}px`;
}

export function enableReadingMask() {
  ensureReadingMask();

  if (!onReadingMaskMove) {
    onReadingMaskMove = (e: MouseEvent) => {
      updateReadingMask(e.clientY);
    };

    document.addEventListener("mousemove", onReadingMaskMove, true);
  }

  updateReadingMask(window.innerHeight / 2);
}

export function disableReadingMask() {
  if (onReadingMaskMove) {
    document.removeEventListener("mousemove", onReadingMaskMove, true);
    onReadingMaskMove = null;
  }

  readingMaskEl?.remove();
  readingMaskEl = null;
  readingMaskWindowEl = null;
  readingMaskTopEl = null;
  readingMaskBottomEl = null;

  removeStyleTag(STYLE_ID);
}
